export enum GraphNodeOutputState {
  Idle = 'idle',
  Running = 'running',
  Success = 'success',
  Error = 'error',
}

export enum GraphNodeOutputType {
  String = 'string',
  Boolean = 'boolean',
  Number = 'number',
  Json = 'json',
  Empty = 'empty',
}

export enum TerminalNodeState {
  Idle = 'idle',
  Success = 'success',
  Error = 'error',
}

// TODO: The value should probably not be unknown but instead be parsed somewhere during the fetch stage.
export interface GraphNodeOutputValue {
  type: GraphNodeOutputType;
  value?: unknown;
}

export interface GraphNodeTypeDefinition {
  id: string;
  title: string;
  category: string;
  description: string;
  icon: string;
  compatibility?: NodeTypeCompatibility;
}

export enum NodeTypeCompatibility {
  Compatible = 'compatible',
  Incompatible = 'incompatible',
}
